import { render, staticRenderFns } from "./OptoutsModal.vue?vue&type=template&id=1a44f80b&scoped=true"
import script from "./OptoutsModal.vue?vue&type=script&lang=js"
export * from "./OptoutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44f80b",
  null
  
)

export default component.exports